import { IApiResponse } from "../../models";

/* eslint-disable no-unused-vars */
export enum EOtpMethod {
  SMS = "SMS",
  WHATSAPP = "WHATSAPP",
}

/** Per-country phone rules served by the backend — same contract Waffy-web-next uses. */
export interface IPhoneRuleConfig {
  countryCode: string;
  countryName: string;
  countryNameAr: string;
  countryFlag: string;
  enabled: boolean;
  nationalNumberLength: number;
  // null when hasExtraZeroPrefix is false
  nationalNumberLengthWithZero: number | null;
  hasExtraZeroPrefix: boolean;
  allowedPrefixes: string[];
  defaultOtpMethod: EOtpMethod;
  resendOtpMethods: EOtpMethod[];
}

export interface IPhoneRuleConfigsResponseData {
  configs: IPhoneRuleConfig[];
}

export type IPhoneRuleConfigsResponse =
  IApiResponse<IPhoneRuleConfigsResponseData>;
